/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {DB_Organization} from "@app/ir-q-app-common/types/care-center/organization";
import {BaseComponent, Dialog_Builder, DialogModule} from "@intuitionrobotics/thunderstorm/frontend";
import {DialogCard} from "../../widget/DialogCard";
import {OrganizationsModule} from "@modules/OrganizationsModule";
import {ErrorToast} from "../../../themes/toasts";
import {PatientsContext} from "../patients/PatientsContext";
import {OrganizationsContext, OrganizationsContextType} from "./OrganizationsContext";

type State = {
    loading: boolean
}
type Props = {
    organization: DB_Organization;
}

export class DeleteOrganizationDialog
    extends BaseComponent<Props, State> {

    public static show(organization: DB_Organization) {
        new Dialog_Builder(
            <DeleteOrganizationDialog
                organization={organization}
            />
        ).setAllowIndirectClosing(true)
            .show();
    }

    constructor(props: Props) {
        super(props);

        this.state = {
            loading: false
        };
    }

    private submit = (orgCtx: OrganizationsContextType) => {
        OrganizationsModule.deleteSync(this.props.organization._id).then(() => {
            orgCtx.deleteOrganizations(this.props.organization._id);
            DialogModule.close();
        }).catch(console.error);
    };

    render() {
        return <PatientsContext.Consumer>{
            ({patients}) => {
                return <OrganizationsContext.Consumer>
                    {orgCtx => <DialogCard
                        showX={true}
                        loading={this.state.loading}
                        content={<p>If you delete this organization, you will not be able to undo this action</p>}
                        saveLabel={`Delete`}
                        cancelLabel={"Cancel"}
                        title={`Delete ${this.props.organization.name}`}
                        onSave={() => {
                            const patient = Object.values(patients).find(p => p?.organizationId === this.props.organization._id)
                            if (patient)
                                ErrorToast(`Cannot delete organization ${this.props.organization.name} since it is assigned to customer ${patient.name}`)
                            else {
                                this.setState({loading: true}, () => this.submit(orgCtx));
                                // Keep dialog open.
                                return true;
                            }
                        }}
                    />}
                </OrganizationsContext.Consumer>
            }

        }</PatientsContext.Consumer>
    }
}
